import React, { useEffect, useState, version } from 'react';
import CustomSelect from "../../../../../../Components/Common/CustomSelect";
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { approveCreative, getComments, getCreatives, openCampaign } from '../../../../../../slices/campaigns/thunk';
import { Container, Row, Col, Card, Badge } from "reactstrap";
import BannerCard from '../../../Components/BannerCard';
import { toggleAddImageModal, toggleAddVersionModal, toggleCommentModal, toggleCreativeFilterModal, toggleDuplicateSetModal, toggleSettingsModal } from '../../../../../../slices/modals/reducer';
import DuplicateSetModal from '../../../Components/Modals/DuplicateSetModal';
import { resetVersionDetails, setCommentRelationId, setCommentType, setCurrentVersion, setFilteredCreatives, setVersionDetails } from '../../../../../../slices/campaigns/reducer';
import { setVersionPath } from '../../../../../../slices/auth/menu/reducer';
import SettingsModal from '../../../Components/Modals/SettingsModal';
import AddNewCreative from './AddNewCreative';
import AddNewVersion from './AddNewVersion';
import FilterModal from '../../../Components/Modals/FilterModal';
import Comment from "../../../Components/Modals/CommentsModal";
import SettingsButton from '../../../Components/Buttons/SettingsButton';
import NewVersionBtn from '../../../Components/Buttons/NewVersionBtn';
import DuplicateVersionBtn from '../../../Components/Buttons/DuplicateVersionBtn';
import NewCreativeBtn from '../../../Components/Buttons/NewCreativeBtn';
import PublishBtn from '../../../Components/Buttons/PublishBtn';
import CommentBtn from '../../../Components/Buttons/CommentBtn';
import ShowcaseBtn from '../../../Components/Buttons/ShowcaseBtn';
import ApproveAllBtn from '../../../Components/Buttons/ApproveAllBtn';
import Filters from '../../../Components/Buttons/Filters';
import StatusBadge from '../../../Components/StatusBadge';
import SwitchVersion from '../../../Components/SwitchVersion';
import ShowcaseModal from '../../../Components/Modals/ShowcaseModal';
import { useLocation } from 'react-router-dom';
import { openPublishPage } from '../../../../../../slices/publish/thunk';

function VersionPage() {
  const dispatch = useDispatch();
  const location = useLocation();
  // Select All Versions
  const selectVersionsState = createSelector((state) => state, (state) => ({
    versions: state.Campaign.versions,
    currentVersion: state.Campaign.currentVersion,
    uploadLimits: state.Upload.uploadLimits,
    currentCampaign: state.Campaign.currentCampaign
  }));
  const { versions, currentVersion, uploadLimits, currentCampaign } = useSelector(selectVersionsState);
  
  // useEffect(() => {
  //   async function waitOpening() {
  //     if (currentCampaign && currentVersion === null) {  
  //       await dispatch(openCampaign(currentCampaign));
  //     }
  //   }
  //   waitOpening();
  // }, [currentVersion]);

  // Select Creative State
  const selectCreativeState = createSelector((state) => state.Campaign, (state) => ({
    creatives: state.creatives,
    filteredCreatives: state.filteredCreatives
  }));
  const { creatives, filteredCreatives } = useSelector(selectCreativeState);

  // useEffect(() => {
  //   if (creatives !== null) {
  //     console.log('effect tetiklendi');
  //     dispatch(setFilteredCreatives(creatives));
  //   }
  // }, [creatives]);

  return (
    <React.Fragment>
      <Container fluid>
        <Row>
          <Card className='p-3 mb-3 d-flex flex-row flex-wrap align-items-center justify-content-between gap-2'>
            <div className='d-flex align-items-center gap-2'>
              <SwitchVersion />
              <SettingsButton />
              <NewVersionBtn />
              <DuplicateVersionBtn />
            </div>
            <div className='d-flex align-items-center gap-2'>
              <NewCreativeBtn />
              <PublishBtn onClick={() => dispatch(openPublishPage())} />
            </div>
          </Card>
        </Row>
        <Row>
          <Card className='px-0 mb-3 w-100 d-flex flex-row flex-wrap gap-2 align-items-center justify-content-between bg-transparent border-0 shadow-none'>
            <div>
              <StatusBadge />
            </div>
            <div className='d-flex flex-wrap align-items-center gap-2'>
              <CommentBtn />
              <ShowcaseBtn />
              <ApproveAllBtn />
              <Filters />
            </div>
          </Card>
        </Row>
      </Container>
      <Row>
        {(filteredCreatives || []).length > 0 ?
          filteredCreatives.map((item, idx) => {
            return (
              <Col xxl={4} key={idx}>
                <BannerCard  idx={idx}
                  id={item._id}
                  type={'image'}
                  size={item?.size}
                  thumbnail={item?.path}
                  comments={item?.comments}
                  approvement={item?.approvement}
                  published={item?.published}
                  showEdit={true}
                  editableInFigmaPlugin={false}
                  isCreativeCreated={true} />
              </Col>
            )
          })
          : null}
      </Row>
      <DuplicateSetModal />
      <SettingsModal />
      <AddNewCreative dropFileType={uploadLimits?.find(item => item.type === "image")} />
      <AddNewVersion dropFileType={uploadLimits?.find(item => item.type === "image")} />
      <FilterModal />
      <ShowcaseModal />
      <Comment />
    </React.Fragment>
  )
}

export default VersionPage
